import './styles/guide.css';
import { bindFeedbackFormTracking, bindGuideTracking, initAnalytics } from './analytics';
import './guide';

initAnalytics();
bindFeedbackFormTracking();
bindGuideTracking();
